import {CommonModule} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {DocumentFile} from "@ui-kit/webkit/components/image-carousel/image-carousel.model";

@Component({
  selector: 'app-image-carousel',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit {
  currentIndex: number;
  thumbnailStartIndex = 0;
  thumbnailsToShow = 5;
  visibleThumbnails: DocumentFile[] = [];

  constructor(
    public dialogRef: MatDialogRef<ImageCarouselComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      images: DocumentFile[];
      currentIndex: number;
    }
  ) {
    this.currentIndex = data.currentIndex;
  }

  ngOnInit() {
    this.updateVisibleThumbnails();
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.adjustThumbnailVisibility();
    }
  }

  next() {
    if (this.currentIndex < this.data.images.length - 1) {
      this.currentIndex++;
      this.adjustThumbnailVisibility();
    }
  }

  previousThumbnailSet() {
    if (this.thumbnailStartIndex > 0) {
      this.thumbnailStartIndex = Math.max(0, this.thumbnailStartIndex - this.thumbnailsToShow);
      this.updateVisibleThumbnails();
    }
  }

  nextThumbnailSet() {
    if (this.thumbnailStartIndex + this.thumbnailsToShow < this.data.images.length) {
      this.thumbnailStartIndex += this.thumbnailsToShow;
      this.updateVisibleThumbnails();
    }
  }

  setCurrentImage(index: number) {
    this.currentIndex = index;
  }

  private updateVisibleThumbnails() {
    this.visibleThumbnails = this.data.images.slice(
      this.thumbnailStartIndex,
      this.thumbnailStartIndex + this.thumbnailsToShow
    );
  }

  private adjustThumbnailVisibility() {
    // Ensure current image is visible in thumbnails
    if (this.currentIndex < this.thumbnailStartIndex) {
      this.thumbnailStartIndex = Math.floor(this.currentIndex / this.thumbnailsToShow) * this.thumbnailsToShow;
      this.updateVisibleThumbnails();
    } else if (this.currentIndex >= this.thumbnailStartIndex + this.thumbnailsToShow) {
      this.thumbnailStartIndex = Math.floor(this.currentIndex / this.thumbnailsToShow) * this.thumbnailsToShow;
      this.updateVisibleThumbnails();
    }
  }
}
